<div
  *transloco="let t; read: 'widgets.analytic-item-selector'"
  class="xi-modal__container crosstab-analytic-items__container"
>
  <h2 class="xi-modal__title">{{ t('set-analytic-items') }}</h2>

  <div class="xi-modal__content crosstab-analytic-items__content">
    <div class="crosstab-analytic-items__column-header">
      <h3>{{ t('row') }}</h3>
    </div>

    <div class="crosstab-analytic-items__column-header"></div>

    <div class="crosstab-analytic-items__column-header">
      <h3>{{ t('column') }}</h3>
    </div>

    <div class="crosstab-analytic-items__column-header"></div>

    @if (!isLoading) {
      <app-analytic-item-selector
        #rowAnalyticItemSelector
        [isRowSelector]="true"
        [widget]="widget"
        [widgetDataSource]="widgetDataSource"
        [report]="report"
        [analyticItemTypes]="analyticItemTypes"
        [analyticItem]="originalRowAnalyticItem"
        [subtypes]="originalRowSubTypes"
        (analyticItemChange)="onAnalyticItemChange($event, 'row')"
        (subtypesChange)="rowSubTypes = $event"
        [(customFieldSelected)]="rowCustomFieldSelected"
        [(standardFieldSelected)]="rowStandardFieldSelected"
        [(sectionPropertySelected)]="rowSectionPropertySelected"
      >
      </app-analytic-item-selector>

      <div class="crosstab-analytic-items__column-wrapper">
        @if (rowIsSectionSelectorAvailable) {
          <app-section-selector
            [sectionMetadata]="sectionMetadata"
            [value]="rowSelectedSections"
            (sectionSelect)="onSectionSelected($event, 'row')"
          ></app-section-selector>
        }
      </div>

      <app-analytic-item-selector
        #columnAnalyticItemSelector
        [widget]="widget"
        [widgetDataSource]="widgetDataSource"
        [report]="report"
        [analyticItemTypes]="analyticItemTypes"
        [analyticItem]="originalColumnAnalyticItem"
        [subtypes]="originalColumnSubTypes"
        (analyticItemChange)="onAnalyticItemChange($event, 'column')"
        (subtypesChange)="columnSubTypes = $event"
        [(customFieldSelected)]="columnCustomFieldSelected"
        [(standardFieldSelected)]="columnStandardFieldSelected"
        [(sectionPropertySelected)]="columnSectionPropertySelected"
      >
      </app-analytic-item-selector>

      <div class="crosstab-analytic-items__column-wrapper">
        @if (columnIsSectionSelectorAvailable) {
          <app-section-selector
            [sectionMetadata]="sectionMetadata"
            [value]="columnSelectedSections"
            (sectionSelect)="onSectionSelected($event, 'column')"
          ></app-section-selector>
        }
      </div>
    }
  </div>

  <div class="xi-modal__actions crosstab-analytic-items__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <xi-default-button
      [text]="t('apply')"
      [disabled]="!isValid"
      [tooltipDisplayOnDisabled]="true"
      [tooltip]="!isValid ? { text: invalidSelectionTooltip } : undefined"
      (onClick)="apply()"
    ></xi-default-button>
  </div>
</div>
